import React, { useEffect, Fragment } from 'react';
import { pageDefaultTitle, isIFRAMEUrl } from 'Root/constants';
import content from 'Content/content.json';
import { language } from 'Root/constants';

import './cookiePolicy.scss';

const CookiePolicy = () => {

  const data = content.data['cookiePolicy'][language] || [];
  const prefixData = data.prefix || [];
  const suffixData = data.suffix || [];

  useEffect(() => {
    if (typeof window.OneTrust !== "undefined") {
      window.OneTrust.initializeCookiePolicyHtml();
    }
  },[]);

  useEffect(() => {
    document.title = pageDefaultTitle + "|Cookie Policy";
    return () => {
      document.title = pageDefaultTitle;
    }
  }, []);

  return (
    <Fragment>
      <div className="cookie-policy-content-wrapper">
        {prefixData.map((item, index) => (
          <div key={item} className="cookie-policy-content-prefix" dangerouslySetInnerHTML={{ __html: item }}/>
        ))}
        <button className="ot-sdk-show-settings" id="ot-sdk-btn">Cookie Settings</button>
        <div id="ot-sdk-cookie-policy">&nbsp;</div>
        {suffixData.map((item, index) => (
          <div key={item} className="cookie-policy-content-suffix" dangerouslySetInnerHTML={{ __html: item }}/>
        ))}
      </div>
    </Fragment>
  );
};

export default CookiePolicy;
